import React from 'react';
import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';

function Icon({
    name,
    size = 24,
    color = "#E9A969", // default stroke color
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const IconComponent = LucideIcons[name];

    if (!IconComponent) {
        return (
            <HelpCircle
                size={size}
                stroke={color} // <-- use stroke, not color
                strokeWidth={strokeWidth}
                className={className}
                {...props}
            />
        );
    }

    return (
        <IconComponent
            size={size}
            stroke={color} // <-- use stroke
            strokeWidth={strokeWidth}
            className={className}
            {...props}
        />
    );
}

export default Icon;
